<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="dedication">
<div class="text" id="dedication-text">
<div class="blockquote-container prose with-attribution">
<blockquote class="prose with-attribution">
<div class="paragraph-and-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first dedication-content"><i>This book is dedicated in loving memory of Nina Paules. Her encouragement, love, and support of us as authors has been an inspiration. We know Nina is in Heaven, rejoicing with the Lord Jesus Christ. Being surrounded by so great a cloud of witnesses who is still cheering us on to greater works. Nina will always be loved and remembered for the good she has done. Her memory lives in each of us.</i></p>
<p class="blockquote-attribution blockquote-position-last">REV. DR. TERESA ALLISSA CITRO AND DR. LINDA AGNES KNOWLES</p>
</div>
<div class="paragraph-and-attribution">
<p class="subsq blockquote-content blockquote-content-prose dedication-content"><i>This book is dedicated to my beloved mother, Roberta “Susie” Young, who was a kind, supportive, and loving role model to me throughout her life.</i></p>
<p class="blockquote-attribution blockquote-position-last">DR. NICHOLAS D. YOUNG</p>
</div>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?117c1f18